"use client";

import { useState } from "react";
import { Lock } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { WaitlistButton } from "@/components/billing/waitlist-button";
import { UpgradeCheckoutButton } from "@/components/billing/upgrade-checkout-button";
import { PAYMENTS_ENABLED, FREE_SHOWCASE_TICKERS } from "@/lib/config";
import { joinWithUnd } from "@/lib/text";

const showcaseNames = joinWithUnd(FREE_SHOWCASE_TICKERS.map((t) => t.name));

/**
 * "Suche nach einer nicht-Basis-Aktie ohne Account → Popup" (backlog.md -> [Punkt 6a]) -
 * ergaenzt die bereits bestehende, passive `PremiumGate`-Verschwommenheit auf der
 * Aktienseite selbst (app/[symbol]/page.tsx) um einen aktiven Hinweis direkt beim
 * Landen/Suchen, statt nur beilaeufig einen unscharfen Bereich zu bemerken. Bewusst
 * dismissable (Escape/Backdrop/X funktionieren normal, anders als EmailGateModal) - die
 * angeteaserte Vorschau darunter bleibt durchsuchbar/lesbar, kein Hard-Block ("Kaufanreiz
 * statt Komplettsperre"-Prinzip, siehe premium-gate.tsx). Rendert nur, wenn die aufrufende
 * Seite bereits `!hasFullStockAccess(...)` festgestellt hat - kennt selbst keine
 * Tier-Logik, damit der echte, servergepruefte Tier-Stand nicht dupliziert werden muss.
 */
export function TierGateModal({ companyName }: { companyName: string }) {
  const [open, setOpen] = useState(true);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <Lock className="h-5 w-5 text-gold-text" aria-hidden="true" />
            <DialogTitle className="font-serif text-xl">{companyName} braucht Pro oder Max</DialogTitle>
          </div>
          <DialogDescription>
            {showcaseNames} sind komplett kostenlos einsehbar. Für {companyName} und alle
            weiteren Aktien schaltet Erikonomie Pro oder Max den vollständigen Score und alle
            Kategorien frei.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-2">
          {PAYMENTS_ENABLED ? (
            <UpgradeCheckoutButton tier="pro" label="Jetzt freischalten" />
          ) : (
            <WaitlistButton tier="pro" />
          )}
          <Button type="button" variant="ghost" size="sm" onClick={() => setOpen(false)}>
            Erstmal nur die Vorschau ansehen
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
